export class FieldType {
    ID: number;
    Name: string;
}

export default FieldType;